import {
  TIMETABLE_TIMESLOT_CONFIGURATION,
  timetable_timeslot_configurationQuery,
  timetable_timeslot_configurationQueryVariables,
} from '@app-types/graphql-types';
import { ApolloQueryResult } from '@apollo/client';
import { apolloClient } from '@lib/apollo';

export const getDefaultTimeSlotConfigurationData = (): Promise<
  ApolloQueryResult<timetable_timeslot_configurationQuery>
> => {
  return apolloClient.query<timetable_timeslot_configurationQuery, timetable_timeslot_configurationQueryVariables>({
    query: TIMETABLE_TIMESLOT_CONFIGURATION,
    variables: {
      where: {
        default: {
          _eq: true,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });
};
